export const SUBNAV_LINKS = {
  logo: {
    label: 'GitHub Copilot',
    url: '/features/copilot',
  },
  items: [
    {
      label: 'For business',
      url: '/features/copilot/copilot-business',
    },
    {
      label: 'Extensions',
      url: '/features/copilot/extensions',
    },
    {
      label: 'Tutorials',
      url: '/features/copilot/tutorials',
    },
    {
      label: 'What’s new',
      url: '/features/copilot/whats-new',
    },
    {
      label: 'Plans',
      url: '/features/copilot/plans',
    },
  ],
}
